import React from 'react'
import MessageUI from '../../widgets/output/MessageUI'
import ButtonLinkUI from '../../widgets/action/ButtonLinkUI'
import PublicPageSF from '../../templates/PublicPageSF'

const MessagePageUI = ({context, messageList, messageKey, messageArgs}) =>
  <PublicPageSF context={context} className='pg_message' centered={true}>
    <div className='g_text_center'>
      <MessageUI messageList={messageList} messageKey={messageKey} args={messageArgs} />
    </div>

    <div className='g_text_center g_m_top_100'>
      <ButtonLinkUI to='/' messageList={messageList} labelKey='c_continue' transparent={true} />
    </div>
  </PublicPageSF>

export default MessagePageUI
